import { render } from "./InstructorBlogs.vue?vue&type=template&id=83fbfd3e"
import script from "./InstructorBlogs.vue?vue&type=script&lang=js"
export * from "./InstructorBlogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__